(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ebird-header-footer"] = factory();
	else
		root["ebird-header-footer"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 